import { render } from "./LocationsList.vue?vue&type=template&id=0b111b9e&scoped=true"
import script from "./LocationsList.vue?vue&type=script&lang=js"
export * from "./LocationsList.vue?vue&type=script&lang=js"

import "./LocationsList.vue?vue&type=style&index=0&id=0b111b9e&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b111b9e"]])

export default __exports__